import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "common/ProtectedRoute";
import { ShiftPermission } from "shifts/permissions";
import ShiftUpdate from "./components/ShiftUpdate";
import ShiftEventDetail from "./components/ShiftEventDetail";
import ShiftTypes from "./components/ShiftTypes";
import ShiftCrossReference from "./components/ShiftCrossReference";
import ShiftLogSheet from "./components/ShiftLogSheet";
import YardSchedule from "yard/components/YardSchedule";
import YardDaily from "yard/components/YardDaily";
import YardDailyDetail from "yard/components/YardDailyDetail";
import YardReview from "yard/components/YardReview";

// Everything shift-related lives under /shifts, split by the legacy system each screen
// replaces. Keeping the provenance in the URL means a link tells you which of the two old
// apps a screen came from, which matters while both are still running.
export const ShiftsRouter: FC<{}> = () => {
  return (
    <Routes>
      {/* Ported from the Dashboard app */}
      <Route path="dashboard/update/:yardDailyId/events" element={<ShiftEventDetail />} />
      <Route path="dashboard/update" element={<ShiftUpdate />} />
      {/* Hiding these in the menu is not a control on its own -- the URL still works. The
          route gate is what actually keeps a field manager out of shift master data. */}
      <Route
        path="dashboard/types"
        element={
          <ProtectedRoute permissions={[ShiftPermission.AccessShiftTypes]}>
            <ShiftTypes />
          </ProtectedRoute>
        }
      />
      <Route
        path="dashboard/cross-reference"
        element={
          <ProtectedRoute permissions={[ShiftPermission.AccessCrossReference]}>
            <ShiftCrossReference />
          </ProtectedRoute>
        }
      />
      <Route path="dashboard/log-sheet" element={<ShiftLogSheet />} />

      {/* Ported from the Logistrics app */}
      <Route path="logistrics/schedule" element={<YardSchedule />} />
      <Route path="logistrics/daily/:yardDailyId" element={<YardDailyDetail />} />
      <Route path="logistrics/daily" element={<YardDaily />} />
      <Route path="logistrics/review" element={<YardReview />} />

      <Route index element={<Navigate to="dashboard/update" replace />} />
    </Routes>
  );
};
